import { render, staticRenderFns } from "./HowtoCreateaBroadcast.vue?vue&type=template&id=0c1376ef&"
import script from "./HowtoCreateaBroadcast.vue?vue&type=script&lang=js&"
export * from "./HowtoCreateaBroadcast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports